// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__16pRY","messages":"Chat_messages__2ioVw","dateDivider":"Chat_dateDivider__3OIeJ"};